// src/api/trials/endpoints.ts
// Essais d'extraction (lot L3, tc_embed_be, admin seulement).
export const TRIALS_ENDPOINTS = {
  /** Liste (50 derniers, plus récents d'abord) ; POST = lancer (202, 409 si un essai tourne). */
  BASE: "/v1/knowledge/trials",
  /** Nombre d'objectifs, réglages effectifs avec leur origine, coût estimé par rôle. */
  ESTIMATE: "/v1/knowledge/trials/estimate",
  /** Détail (GET) ; jeter (DELETE). */
  DETAIL: (id: string) => `/v1/knowledge/trials/${id}`,
  /** Écrire les unités de l'essai encore valables (409 si l'essai n'est pas terminé). */
  APPLY: (id: string) => `/v1/knowledge/trials/${id}/apply`,
} as const;
